module.exports = __webpack_public_path__ + "img/banner1.380cbb3d.jpg";